'use client';

export default function GlobalError({ reset }) {
    return (
        <html lang="en">
            <body>
                <div
                    style={{
                        minHeight: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '24px',
                        fontFamily: 'sans-serif',
                        textAlign: 'center',
                    }}
                >
                    <div style={{ maxWidth: 420 }}>
                        <h1
                            style={{
                                fontSize: 22,
                                fontWeight: 700,
                                marginBottom: 8,
                                color: '#1f2937',
                            }}
                        >
                            Something went wrong
                        </h1>
                        <p
                            style={{
                                fontSize: 15,
                                color: '#6b7280',
                                marginBottom: 24,
                            }}
                        >
                            Please try reloading the page. If this keeps
                            happening, contact us at career@wahni.com.
                        </p>
                        <button
                            type="button"
                            onClick={() => reset()}
                            style={{
                                padding: '10px 20px',
                                borderRadius: 8,
                                border: 'none',
                                color: '#fff',
                                fontWeight: 600,
                                cursor: 'pointer',
                                background:
                                    'linear-gradient(to right, #4695F0, #57CCF9)',
                            }}
                        >
                            Reload
                        </button>
                    </div>
                </div>
            </body>
        </html>
    );
}
